import script from "./qwMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./qwMessage.vue?vue&type=script&lang=ts&setup=true"

import "./qwMessage.vue?vue&type=style&index=0&id=20151cc0&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20151cc0"]])

export default __exports__